// @flow

import PubSub from "./util/pubsub";

export const events = {
    show: "show-content-overlay",
    hide: "hide-content-overlay",
};

class SerchPageOverlay {
    static classes = {
        hasOverlay: "has-overlay",
    };

    els: any;
    shouldHideTimeout: ?TimeoutID;

    constructor(els: any) {
        this.els = els;
        this.attachHandlers();
    }

    attachHandlers = () => {
        PubSub.subscribe(events.show, this.show);
        PubSub.subscribe(events.hide, this.hide);
    };

    show = () => {
        // Run after the next tick to ensure it runs after hiding
        requestAnimationFrame(() => {
            // Cancel any hiding requests
            if (this.shouldHideTimeout) {
                clearTimeout(this.shouldHideTimeout);
                this.shouldHideTimeout = null;
            }
            this.els.forEach((el: HTMLElement, idx: number) => {
                el.classList.add(SerchPageOverlay.classes.hasOverlay);
            });
        });
    };

    hide = () => {
        this.shouldHideTimeout = setTimeout(() => {
            this.els.forEach((el: HTMLElement, idx: number) => {
                el.classList.remove(SerchPageOverlay.classes.hasOverlay);
            });
        }, 10);
    };
}

const els = document.querySelectorAll(".page-content--search-page, .footers");
if (els) {
    new SerchPageOverlay(els);
}

export default {
    events,
};
